import * as React from 'react';
import { isWizard } from '../helpers/wizard';
import { getChildren } from '../helpers/node';

type UseNodesResult = {
  node: Elvita.Node | Elvita.WizardItem | undefined;
  breadcrumbs: Elvita.BreadCrumb[];
};

export function useNodes(
  data: Elvita.Node | Elvita.WizardItem | undefined,
  childId: string | undefined,
  path: string | undefined,
  label?: string,
): UseNodesResult {
  const [node, setNode] = React.useState<UseNodesResult>({
    node: undefined,
    breadcrumbs: [],
  });

  React.useEffect(() => {
    const setBredcrumbs = (data: Elvita.Node | Elvita.WizardItem) => {
      const pathBreadcrumb: Elvita.BreadCrumb = {
        label: label ?? '',
        url: isWizard(data) ? `/wizard/${path}` : `/browse/${path}`,
      };

      if (childId && path) {
        const { nodeData, breadcrumbs } = getChildren(data, childId, path);
        setNode({
          node: nodeData,
          breadcrumbs: [pathBreadcrumb, ...breadcrumbs],
        });
      } else {
        setNode({ node: data, breadcrumbs: [pathBreadcrumb] });
      }
    };

    if (data !== undefined) {
      setBredcrumbs(data);
    }
  }, [data, childId, path, label]);

  return { node: node.node, breadcrumbs: node.breadcrumbs };
}
